import React, { useEffect, useState } from "react";
import { Assort } from "../../../models/Assort";
import { TicketAccess } from "../../../models/TicketAccess";
import { Exercise } from "../../../models/Exercise";
import EAModal from "../../shared/Modal/EAModal";
import "./SingleExerciseDetailsModal/SingleExerciseDetailsModal.scss";
import EADivider from "../../shared/EADivider";
import TicketLineSummary from "../../Universal/TicketLineSummary";
import PreBasketSummary from "../../Universal/PreBasketSummary";
import useCalculatePreBasketQnt from "../../Universal/hooks/useCalculatePreBasketQnt";
import usePreBasket from "../../Universal/hooks/usePreBasket";
import useBasketManager from "../../FinalizePage/hooks/useBasketManager";
import { BasketItem } from "../../../models/BasketItem";
import { useTranslation } from "react-i18next";
import EAAlert from "../../shared/EAAlert";

interface IProps {
  exercise: Exercise;
  onClose: () => void;
  tickets: Assort[];
  ticketAccess: TicketAccess;
}

const SingleExerciseTicketModal: React.FC<IProps> = ({ exercise, onClose, tickets, ticketAccess }) => {
  const { t } = useTranslation();
  const { getBasket } = useBasketManager();
  const { preBasket, addItemToBasket, removeItemFromBasket, clearBasket, setItemQuantity } = usePreBasket();
  const [limit, setLimit] = useState(0);
  const { qntState } = useCalculatePreBasketQnt(preBasket);

  const handleDeleteBasket = () => {
    clearBasket();

    setTimeout(() => {
      getBasket();
    }, 200);
  };

  useEffect(() => {
    if (exercise) {
      setLimit(exercise.capacity - (exercise.prereservation + exercise.reserved));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exercise]);

  const ticketsInCurrentBasket = () => preBasket.reduce((acc: number, item: BasketItem) => acc + item.qnt, 0);

  return (
    <EAModal isOpen onClose={onClose} hideButtons title="">
      <div className="single-exercise-details-modal__container">
        {exercise.eventMessage && (
          <div className="single-exercise-details-modal__left-column">
            <div className="exercise-picture" style={{ backgroundImage: `url(${exercise.eventMessage})` }}>
              <b>{exercise.zone.displayName}</b>
            </div>
          </div>
        )}
        <div className="single-exercise-details-modal__right-column">
          <h5>{exercise.name}</h5>
          <EADivider />
          <article dangerouslySetInnerHTML={{ __html: exercise.description }}></article>
        </div>
      </div>
      {tickets && exercise && (
        <div className="tickets">
          <div>
            {tickets.map((itemTicket, index) => (
              <div key={index}>
                <TicketLineSummary
                  item={itemTicket}
                  exercise={ticketAccess}
                  preBasket={preBasket}
                  addItemToBasket={addItemToBasket}
                  removeItemFromBasket={removeItemFromBasket}
                  setItemQuantity={setItemQuantity}
                  ticketLimit={limit}
                  qntState={qntState}
                  allowManualInput={true}
                />
              </div>
            ))}

            {limit === ticketsInCurrentBasket() && (
              <EAAlert type="error" message={t("nie_mozesz_dodac_wiekszej_ilosci_biletow_do_koszyka")} />
            )}
            <PreBasketSummary ticketLimit={limit} preBasket={preBasket} clearBasket={handleDeleteBasket} />
          </div>
        </div>
      )}
    </EAModal>
  );
};

export default SingleExerciseTicketModal;
